namespace Solovis.Site.Search {

    export class ExtendedSearchResultsDialog {

        public _query;
        public _dialogWindow: Solovis.UI.Dialog;

        constructor(options) {
            var self = this;

            this._query = options.query ? options.query : null;

            var desiredWidth = Math.min($(window).width() * .8, 600);
            var desiredHeight = Math.min($(window).height() * .8, 400);

            var minWidth = 100;
            var minHeight = 100;

            var editorDiv = $("<div>")
                .addClass("editordiv")
                .css("box-sizing", "content-box")
                .css("overflow", "hidden")
                .css("min-height", "75px");

            var extendedSearchResultsControl = new Solovis.Site.Search.ExtendedSearchResultsControl({
                controlHost: editorDiv,
                query: this._query
            });

            $(extendedSearchResultsControl).on("selectionChanged", function () {
                self._dialogWindow.close();
            });

            extendedSearchResultsControl.setAsCurrentControl();

            this._dialogWindow = new Solovis.UI.Dialog({
                container: editorDiv,

                title: "More Results For \"" + this._query.filterText + "\"",

                modal: true,
                center: true,
                actions: ["Close"],
                autoOpen: true,
                destroyOnClose: true,
                width: desiredWidth,
                minWidth: minWidth,
                minHeight: minHeight,
                height: desiredHeight,
                noPaddingOnContent: true,

                resize: function () {
                    var overallHeight = this.getAvailableContentHeight();
                    extendedSearchResultsControl.setAvailableHeight(overallHeight);
                },

                activate: function () {
                    var overallHeight = this.getAvailableContentHeight();
                    extendedSearchResultsControl.setAvailableHeight(overallHeight);
                    extendedSearchResultsControl.focusFilter();
                }

            });
        }

        public static showDialog(options) {
            var dialog = new Solovis.Site.Search.ExtendedSearchResultsDialog(options);
        }
    }  
    
}